// extracted by mini-css-extract-plugin
export var about = "styles-module--about--93PZr";
export var introLink = "styles-module--introLink--N+s93";